import { combineReducers } from "@reduxjs/toolkit";
import { image } from "./image";
import { model } from "./model";
import { crop } from "./cropTools";

export const reducers = combineReducers({ image, model, crop });
